export default {
  // Label management
  labelManagement: "Label Management",
};
